// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-page-header[data-v-df039db6] {\r\n    margin-bottom: 15px;\n}\r\n", ""]);
// Exports
module.exports = exports;
